import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@mui/material";
import custom99GiftTheme from "./shared/theme";
import { Provider } from "react-redux";
import store from "./store";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {  HelmetProvider } from 'react-helmet-async';
import { register } from 'swiper/element/bundle';
import { GoogleOAuthProvider } from "@react-oauth/google";


// FONT FAMILY IMPORT
// onest
import "@fontsource/onest/400.css";
import "@fontsource/onest/500.css";
import "@fontsource/onest/600.css";
import "@fontsource/onest/700.css";

// be-vietnam-pro
import "@fontsource/be-vietnam-pro/400.css";
import "@fontsource/be-vietnam-pro/500.css";
import "@fontsource/be-vietnam-pro/600.css";
import "@fontsource/be-vietnam-pro/700.css";

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}


register();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_99GIFT_GOOGLE_CLIENT_ID || null}>
    <HelmetProvider>
      <Provider store={store}>
        <ThemeProvider theme={custom99GiftTheme}>
          <App />
          <ToastContainer />
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  </GoogleOAuthProvider>
);
